module.exports = __webpack_public_path__ + "static/media/login.e4f218e8.svg";